export const TTW_PATHS = {
  TTW: 'ttw',
  PICKUP_ORDER: 'pickup-order',
  HELP_CENTER: 'help-center',
  DRIVER_NOTIFICATION: 'driver-notification',
  DISPENSING_ORDER: 'dispensing-order',
  WAITING_QUEUE: 'waiting-queue',
};

export const TTW_ROUTES = {
  HOME: `/${TTW_PATHS.TTW}`,
  PICKUP_ORDER: `/${TTW_PATHS.TTW}/${TTW_PATHS.PICKUP_ORDER}`,
  HELP_CENTER: `/${TTW_PATHS.TTW}/${TTW_PATHS.HELP_CENTER}`,
  DRIVER_NOTIFICATION: `/${TTW_PATHS.TTW}/${TTW_PATHS.DRIVER_NOTIFICATION}`,
  DISPENSING_ORDER: `/${TTW_PATHS.TTW}/${TTW_PATHS.DISPENSING_ORDER}`,
  WAITING_QUEUE: `/${TTW_PATHS.TTW}/${TTW_PATHS.WAITING_QUEUE}`,
} as const;
